$(function () {
    if ($('#SubscriptionPageContent').length) {
        if ($('#SubscriptionPageContainer').css('position') == 'relative') {
            $('#SubscriptionPageContainer').css('height', $('#SubscriptionPageContent').height() + 'px');
        }
        FixSubscriptionOptionsOverflow();

        window.setInterval(function () {
            if ($('#SubscriptionPageContainer').css('position') == 'relative') {
                $('#SubscriptionPageContainer').css('height', $('#SubscriptionPageContent').height() + 'px');
            } else {
                $('#SubscriptionPageContainer').css('height', '');
            }
            FixSubscriptionOptionsOverflow();
        }, 100);
    }

    if ($('.delivery-options input[type="radio"]:checked').length > 0) {
        $('.FirstBoxDeliveryDate').val($('.delivery-options input[type="radio"]:checked').data('selecteddateforinput'));
    }

    $('.delivery-options input[type="radio"]').on('change', function () {
        $('.delivery-options .border-primary').removeClass('border-primary');
        var WrapperDiv = $(this).parents('.border');
        WrapperDiv.addClass('border-primary');
        if (WrapperDiv.hasClass('custom-date')) {
            $('.custom-date .calendar-area').removeClass('d-none');
        } else {
            $('.custom-date .calendar-area').addClass('d-none');
        }
        var SelectedDateTextValue = $(this).data('selecteddate');
        //console.log(SelectedDateTextValue);
        $('.delivered-by-date').text(SelectedDateTextValue);
        $('.FirstBoxDeliveryDate').val($(this).data('selecteddateforinput'));
        $('.FirstBoxDeliveryDateSummary').text(SelectedDateTextValue);
        var DateSplit = $(this).data('selecteddateforinput').split('-');

        var nextBoxDate1 = new Date(DateSplit[0], DateSplit[1], 1); // this already adds one to the month total because JS months start zero!
        //console.log(nextBoxDate1);
        $('.NextBoxMonth').text(monthNames[nextBoxDate1.getMonth()]);


        if ($('.addToCartButton').data('christmasorder') == 1) {
            $('.TimeOfMonth[data-time="middle"]').addClass('d-none');
            $('.TimeOfMonth[data-time="end"]').removeClass('d-none');
            $('.NextBoxMonth').text(monthNames[0]);
     }
        else if (DateSplit[2] > 15) {
            $('.TimeOfMonth[data-time="middle"]').addClass('d-none');
            $('.TimeOfMonth[data-time="end"]').removeClass('d-none');
        } else {
            $('.TimeOfMonth[data-time="middle"]').removeClass('d-none');
            $('.TimeOfMonth[data-time="end"]').addClass('d-none');
        }

        CheckDeliveryType();
        WorkOutDisplayPriceIncDelivery();
    });


    $('.delivery-options input[type="radio"]:checked').parents('.form-check').addClass('border-primary');
    //console.log($('.delivery-options input[type="radio"]:checked').val());
    CheckDeliveryType();
    

    function CheckDeliveryType() {
        switch (parseInt($('.delivery-options input[type="radio"]:checked').val())) {
            case 1:
            case 5:
                $('.delivery-option-summary').text('free standard delivery');
                break;
            case 2:
                $('.delivery-option-summary').text('inc. express delivery');
                break;
            case 3:
                $('.delivery-option-summary').text('inc. super express delivery');
                break;
            case 4:
                $('.delivery-option-summary').text('inc. super express Saturday delivery');
                break;
        }
    }
    if ($('.custom-date .calendar-area').length > 0) {
        function ordinal_suffix_of(i) {
            var j = i % 10,
                k = i % 100;
            if (j == 1 && k != 11) {
                return i + "st";
            }
            if (j == 2 && k != 12) {
                return i + "nd";
            }
            if (j == 3 && k != 13) {
                return i + "rd";
            }
            return i + "th";
        }

        function WriteNiceDate(d) {
            var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            var monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];

            return days[d.getDay()] + ' ' + d.getDate() + ' ' + monthNames[d.getMonth()];
        }

        var MinDate = $('.custom-date .calendar-area').data('firstdate');
        var SelectedDate = $('.custom-date .calendar-area').data('selecteddate');
        var MaxDate = $('.custom-date .calendar-area').data('lastdate');
        var DisabledDates = $('.custom-date .calendar-area').data('disableddates').split(',');
        //console.log(DisabledDates);
        //function WriteDespatchTimes(DeliveryDate, FirstTime) {
        //    //console.log(DeliveryDate);
        //    //var OneDayDispatchDateVal = new Date(DeliveryDate);
        //    ////console.log(OneDayDispatchDateVal);
        //    //OneDayDispatchDateVal.setDate(OneDayDispatchDateVal.getDate() - 1);
        //    ////console.log(OneDayDispatchDateVal);

        //    ////if (!FirstTime) {
        //    ////check that previous day is
        //    //if (OneDayDispatchDateVal.getDay() == 0) { // Sunday
        //    //    OneDayDispatchDateVal.setDate(OneDayDispatchDateVal.getDate() - 2);
        //    //    MinDateVal = tomorrow;
        //    //} else if (OneDayDispatchDateVal.getDay() == 6) { // Saturday
        //    //    OneDayDispatchDateVal.setDate(OneDayDispatchDateVal.getDate() - 1);
        //    //}
        //    ////
        //    ////}
        //    //var TwoDayDispatchDateVal = new Date(OneDayDispatchDateVal);
        //    //if (TwoDayDispatchDateVal.getDay() == 1) { //Monday
        //    //    TwoDayDispatchDateVal.setDate(TwoDayDispatchDateVal.getDate() - 3);
        //    //} else {
        //    //    TwoDayDispatchDateVal.setDate(TwoDayDispatchDateVal.getDate() - 1);
        //    //}

        //    ////check for disabled dates
        //    //var DateOK = true;

        //    //if (DisabledDates.includes(OneDayDispatchDateVal.toISOString().split('T')[0])) {
        //    //    DateOK = false;
        //    //}

        //    //while (!DateOK) {
        //    //    OneDayDispatchDateVal.setDate(OneDayDispatchDateVal.getDate() - 1);
        //    //    //console.log('hello');
        //    //    if (OneDayDispatchDateVal.getDay() == 0) { // Sunday
        //    //        OneDayDispatchDateVal.setDate(OneDayDispatchDateVal.getDate() - 2);
        //    //    } else if (OneDayDispatchDateVal.getDay() == 6) { // Saturday
        //    //        OneDayDispatchDateVal.setDate(OneDayDispatchDateVal.getDate() - 1);
        //    //    }
        //    //    if (!DisabledDates.includes(OneDayDispatchDateVal.toISOString().split('T')[0])) {
        //    //        DateOK = true;
        //    //    }
        //    //}


        //    //DateOK = true;

        //    //if (DisabledDates.includes(TwoDayDispatchDateVal.toISOString().split('T')[0])) {
        //    //    DateOK = false;
        //    //}

        //    //while (!DateOK) {
        //    //    TwoDayDispatchDateVal.setDate(TwoDayDispatchDateVal.getDate() - 1);
        //    //    //console.log('hello');
        //    //    if (TwoDayDispatchDateVal.getDay() == 0) { // Sunday
        //    //        TwoDayDispatchDateVal.setDate(TwoDayDispatchDateVal.getDate() - 2);
        //    //    } else if (TwoDayDispatchDateVal.getDay() == 6) { // Saturday
        //    //        TwoDayDispatchDateVal.setDate(TwoDayDispatchDateVal.getDate() - 1);
        //    //    }
        //    //    if (!DisabledDates.includes(TwoDayDispatchDateVal.toISOString().split('T')[0])) {
        //    //        DateOK = true;
        //    //    }
        //    //}

        //    //console.log(TwoDayDispatchDateVal);

        //    var monthNames = ["January", "February", "March", "April", "May", "June",
        //        "July", "August", "September", "October", "November", "December"
        //    ];

        //    //$('.OneDayDispatchDate').text(ordinal_suffix_of(OneDayDispatchDateVal.getDate()) + ' ' + monthNames[OneDayDispatchDateVal.getMonth()]);
        //    //$('.TwoDayDispatchDate').text(ordinal_suffix_of(TwoDayDispatchDateVal.getDate()) + ' ' + monthNames[TwoDayDispatchDateVal.getMonth()]);
        //    //  $('.OneDayDispatchDate').text(OneDayDispatchDateVal);
        //    //  $('.TwoDayDispatchDate').text(TwoDayDispatchDateVal);
        //    ////OneDayDispatchDate
        //    //TwoDayDispatchDate


        //}

        //const firstDeliveryDate = new Date();
        //if (firstDeliveryDate.getHours() > 13) { // after 2pm
        //    console.log('sdfs');
        //    firstDeliveryDate.setDate(tomorfirstDeliveryDaterow.getDate() + 1); // add a day
        //}
        //var tomorrow = new Date();
        ////console.log(tomorrow);
        //if (tomorrow.getHours() > 13) { // after 2pm
        //    tomorrow.setDate(tomorrow.getDate() + 1); // add a day
        //}
        //tomorrow.setDate(tomorrow.getDate() + 1);
        //var MinDateVal = new Date(tomorrow);
        ////console.log(tomorrow);
        ////console.log(tomorrow.getDay());

        //if (tomorrow.getDate() == 0) { // Sunday
        //    tomorrow.setDate(tomorrow.getDate() + 1);
        //    MinDateVal = tomorrow;
        //} else if (tomorrow.getDay() == 6) { // Saturday
        //    //tomorrow.setDate(tomorrow.getDate() + 2);
        //}

        //WriteDespatchTimes(DeliveryDate)
        //check "tomorrow" isn't a holiday
        //var disabledDays = ['2021-10-11', '2020-12-25', '2020-12-28', '2021-01-01', '2019-12-30', '2019-12-31', '2020-12-29', '2020-12-30', '2020-12-31', '2021-01-01', '2020-12-22', '2021-04-02', '2021-04-05', '2021-05-03', '2021-05-31', '2021-08-30', '2021-12-27', '2021-12-28', '2022-01-03', '2022-04-15', '2022-04-18', '2022-05-02', '2022-06-02', '2022-06-03', '2022-08-29', '2022-12-26', '2022-12-27'];
        //console.log(DisabledDates);
        //console.log(disabledDays);
        //console.log(tomorrow.toISOString().split('T')[0]);
        //var DateOK = true;

        //if (DisabledDates.includes(tomorrow.toISOString().split('T')[0])) {
        //    DateOK = false;
        //}

        //while (!DateOK) {
        //    tomorrow.setDate(tomorrow.getDate() + 1);
        //    //console.log('hello');
        //    if (tomorrow.getDay() == 0) { // Sunday
        //        tomorrow.setDate(tomorrow.getDate() + 1);
        //    } else if (tomorrow.getDay() == 6) { // Saturday
        //        //tomorrow.setDate(tomorrow.getDate() + 2);
        //    }
        //    if (!DisabledDates.includes(tomorrow.toISOString().split('T')[0])) {
        //        DateOK = true;
        //    }
        //}

        //console.log(MinDate);

        //var tomorrowDateyyyyMMdd = tomorrow.toISOString().split('T')[0];
        //var SelectedDate = MinDate;

        //var sixMonthsDate = new Date();
        //sixMonthsDate.setMonth(sixMonthsDate.getMonth() + 6);
        //var sixMonthsDateyyyyMMdd = sixMonthsDate.toISOString().split('T')[0];
        //console.log(SelectedDate);
        $('.custom-date .calendar-area').pignoseCalendar({
            date: moment(SelectedDate),
            //minDate: MinDateVal.toISOString().split('T')[0],
            minDate: MinDate,
            maxDate: MaxDate,
            week: 1, // Monday
            //           schedules: [{
            //name: 'Lani\'s birthday',
            //               date: moment('2021-10-01')
            //           }, {
            //               name: 'Crimbo',
            //               date: moment('2021-12-25')
            //               }],
            disabledDates: DisabledDates,
            //disabledWeekdays: [0, 6], // SUN (0), SAT (6)
            disabledWeekdays: [0], // SUN (0), SAT (6)
            init: function (context) {
                // This is chaining Element, It is exactly same as the each elements of $('.calendar').
                //var $this = $(this);

                //// You can get target element in `context` variable.
                //var $element = context.element;

                //// You can also get calendar element, It is calendar view DOM.
                //           var $calendar = context.calendar;
                //WriteDespatchTimes(MinDateVal, true);
            },

            select: function (date, context) {

                //// This is selected button Element.
                //var $this = $(this);

                //// You can get target element in `context` variable, This element is same `$(this)`.
                //var $element = context.element;

                //// You can also get calendar element, It is calendar view DOM.
                //var $calendar = context.calendar;

                // Selected dates (start date, end date) is passed at first parameter, And this parameters are moment type.
                // If you unselected date, It will be `null`.
                //console.log(date[0], date[1]);

                //console.log(date);

                //SelectedDate
                if (date[0] != null) {
                    //console.log(date[0]);
                    //console.log(date[0]._i);
                    var JSDate = new Date(date[0]._i)
                    $('.delivered-by-date').text(WriteNiceDate(JSDate));
                    $('.custom-delivery-date').text(WriteNiceDate(JSDate));
                    $('.deliveryoptioncustom').data('selecteddate', WriteNiceDate(JSDate));
                    $('.deliveryoptioncustom').data('selecteddateforinput', JSDate.toISOString().split('T')[0]);
                    $('.FirstBoxDeliveryDate').val(JSDate.toISOString().split('T')[0]);
                    $('.FirstBoxDeliveryDateSummary').text(WriteNiceDate(JSDate));

                    if (JSDate.getDate() > 15) {
                        $('.TimeOfMonth[data-time="middle"]').addClass('d-none');
                        $('.TimeOfMonth[data-time="end"]').removeClass('d-none');
                    } else {
                        $('.TimeOfMonth[data-time="middle"]').removeClass('d-none');
                        $('.TimeOfMonth[data-time="end"]').addClass('d-none');
                    }

                    var nextBoxDate1 = new Date(JSDate.setMonth(JSDate.getMonth() + 1));
                    $('.NextBoxMonth').text(monthNames[nextBoxDate1.getMonth()]);

                    //data-selecteddateforinput

                    //console.log(JSDate);
                    //if (JSDate.getDay() == 0) {
                    //    // Sunday
                    //    $('.delivery-options input').prop('disabled', true).prop('checked', false);
                    //    $('#Sunday').prop('disabled', false).prop('checked', true);

                    //} else

                    SelectedDate = JSDate.toISOString().split('T')[0];

                //    WriteDespatchTimes(JSDate, false);

                //    if (JSDate.getDay() == 6) {

                //        // Saturday
                //        $('.delivery-options input').prop('disabled', true).prop('checked', false);
                //        $('#Express').prop('disabled', false).prop('checked', true);

                //        var diffTime = Math.abs(JSDate - MinDateVal);
                //        var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                //        //console.log(diffTime + " milliseconds");
                //        //console.log(diffDays + " days");

                //        if (diffDays > 1) {
                //            $('#Standard').prop('disabled', false).prop('checked', true);
                //            $('#Express').prop('checked', false);
                //        }
                //        $('#Saturday').prop('disabled', false);
                //    } else if (date[0]._i == tomorrowDateyyyyMMdd) {
                //        //$('#Sunday').prop('disabled', true).prop('checked', false);
                //        $('#Saturday').prop('disabled', true).prop('checked', false);
                //        $('input.standard-three').prop('disabled', false);
                //        $('#Standard').prop('disabled', true);
                //        $('#Express').prop('checked', true);
                //    } else {
                //        $('input.standard-three').prop('disabled', false);
                //        //$('#Sunday').prop('disabled', true).prop('checked', false);
                //        $('#Saturday').prop('disabled', true).prop('checked', false);
                //        //console.log($('input.standard-three:checked').length);
                //        if ($('input.standard-three:checked').length == 0) {
                //            $('#Standard').prop('checked', true);
                //        }
                //    }
                } else {
                    //console.log(SelectedDate.toISOString().split('T')[0]);
                    $('.custom-date .calendar-area').pignoseCalendar('set', SelectedDate);
                    //$('.cal').pignoseCalendar({ date: moment('2021-10-05') });
                    //    $this({
                    //        set: moment(SelectedDate.toISOString().split('T')[0])
                    //});
                }

            }
        }); //creates the calendar

    }


    $('.btn input[name="OptionId"]').on('change', function () {
        if ($(this).is(':checked')) {
            var val = $(this).val();

            $('.btn input[name="OptionId"]').each(function () {
                if ($(this).val() == val && !$(this).is(':checked')) {
                    $(this).trigger('click');
                } else {
                    $(this).removeAttr('checked');
                    // when dealing with toggling buttons, use removeAttr('checked') liberally to prevent triggering bugs
                    // will be fixed if/when upgrading to Bootstrap 5 which replaces most of the button plugin js with css - https://github.com/twbs/bootstrap/pull/30650
                }
            });

            $('[data-option]').addClass('d-none');
            $('[data-option="' + val + '"]').removeClass('d-none');

            $('#ProductName').text($(this).parents('.btn').data('name'));
            $('#ProductSummary').text($(this).parents('.btn').data('summary'));

            ShowHidePlans();
            SetSubscriptionSummary();
        }
    });

    $('.btn input[name="Quantity"]').on('change', function () {
        if ($(this).is(':checked')) {
            var val = $(this).val();
            //console.log(val);

            if (val == 2) {
                $('.grey-box-notification').removeClass('d-none');
            } else {
                $('.grey-box-notification').addClass('d-none');
            }

            $('.btn input[name="Quantity"]').each(function () {
                if ($(this).val() == val && !$(this).is(':checked')) {
                    $(this).trigger('click');
                } else {
                    $(this).removeAttr('checked');
                }
            });

            $('[data-quantity]').addClass('d-none');
            $('[data-quantity="' + val + '"]').removeClass('d-none');

            ShowHidePlans();
            SetSubscriptionSummary();
        }
    });

    $('.btn input[name="PlanLength"]').on('change', function () {
        if ($(this).is(':checked')) {
            var val = $(this).val();

            $('.btn input[name="PlanLength"]').each(function () {
                if ($(this).val() == val && !$(this).is(':checked')) {
                    $(this).trigger('click');
                } else {
                    $(this).removeAttr('checked');
                }
            });

            SetSubscriptionSummary();
        }
    });

    $('.shop-product-portal-btn').on('click', function () {
        //$('.PriceSummary').text(planChecked.parents('.btn').find('.price:visible').first().text());
        //console.log(planChecked.parents('.btn').find('.price:visible').first().data('price'));
        $('.PriceSummary').data('price', $('.productPrice').data('price'));
        WorkOutDisplayPriceIncDelivery();
    });

    // this code has to be *after* the change events are attached to the relevant inputs
    if ($('[data-toggle="buttons"]').length && document.URL.indexOf('#') >= 0) {
        var AutoSelectValues = decodeURIComponent(document.URL.substr(document.URL.indexOf('#') + 1));
        var fragements = AutoSelectValues.split("|");
        $.each(fragements, function (index, value) {
            //console.log(value);
            switch (value.toLowerCase()) {
                case "mens":
                    $('input[name="OptionId"][value="1"]').trigger('click');
                    break;
                case "womens":
                    $('input[name="OptionId"][value="2"]').trigger('click');
                    break;
                case "hishers":
                    $('input[name="OptionId"][value="3"]').trigger('click');
                    break;
                case "1pair":
                    $('input[name="Quantity"][value="1"]').trigger('click');
                    break;
                case "2pairs":
                    $('input[name="Quantity"][value="2"]').trigger('click');
                    break;
                case "monthly":
                    $('input[name="PlanLength"][value="1"]').trigger('click');
                    break;
                case "3months":
                    $('input[name="PlanLength"][value="3"]').trigger('click');
                    break;
                case "6months":
                    $('input[name="PlanLength"][value="6"]').trigger('click');
                    break;
                case "12months":
                    $('input[name="PlanLength"][value="12"]').trigger('click');
                    break;
            }
        });
    }

    $('.select-2-pairs').on('click', function () {
        $('input[name="PlanLength"][value="6"]').trigger('click');
        $('input[name="Quantity"][value="2"]').trigger('click');
        //$('#doubleUpModal').modal('hide')
    });
    $('.select-2-pairs-ss').on('click', function () {
        $('input[name="PlanLength"][value="6"]').trigger('click');
        $('input[name="Quantity"][value="2"]').trigger('click');
        //$('#doubleUpModal').modal('hide')
        //
        $("#setup-sub-link").trigger("click");

    });

    $('#SetUpSubscriptionModal').on('shown.bs.modal', function () {
        SetSubscriptionSummary();
    });

    $('input[name$=".GiftMessageThemeId"]').on('change', function () {
        var GiftMessageThemeId = $('input[name$=".GiftMessageThemeId"]:checked');
        var GiftMessageThemeMinDespatchDate = GiftMessageThemeId.data('mindespatchdate');
        var DespatchDate = $('input[name="Subscription.FirstBoxDespatchDate"], input[name="Product.DespatchDate"]');
        if (typeof GiftMessageThemeMinDespatchDate !== 'undefined' && GiftMessageThemeMinDespatchDate !== '') {
            DespatchDate.attr('min', GiftMessageThemeMinDespatchDate > DespatchDate.data('defaultmin') ? GiftMessageThemeMinDespatchDate : DespatchDate.data('defaultmin'));
        } else {
            DespatchDate.attr('min', DespatchDate.data('defaultmin'));
        }
        var minDate = new Date(DespatchDate.attr('min'));
        var currentDate = new Date(DespatchDate.val());
        if (DespatchDate.val() === '' || currentDate < minDate) {
            DespatchDate.val(formatDate(minDate));
        }
        DespatchDate.trigger('change');

        var DoNotOpenUntil = $('input[name$=".DoNotOpenUntil"]');
        var DoNotOpenUntilEnabled = $('input[type="checkbox"][name$=".DoNotOpenUntilEnabled"]');
        var GiftMessageThemeDefaultDNOUDate = GiftMessageThemeId.data('defaultdnoudate');
        if (typeof GiftMessageThemeDefaultDNOUDate !== 'undefined' && GiftMessageThemeDefaultDNOUDate !== '') {
            DoNotOpenUntil.val(GiftMessageThemeDefaultDNOUDate).trigger('change');
            if ($(this).val() != 6) {
                DoNotOpenUntilEnabled.prop('checked', true).trigger('change');
            }
        }

        if ($(this).val() == 6) {
            //console.log('christmas');
            $('.addToCartButton').data('christmasorder', 1);
            $('.TimeOfMonth[data-time="middle"]').addClass('d-none');
            $('.TimeOfMonth[data-time="end"]').removeClass('d-none');
            $('.NextBoxMonth').text(monthNames[0]);
        } else {
            var DateSplit = $('.delivery-options input[type="radio"]:checked').data('selecteddateforinput').split('-');
            if (DateSplit[2] > 15) {
                $('.TimeOfMonth[data-time="middle"]').addClass('d-none');
                $('.TimeOfMonth[data-time="end"]').removeClass('d-none');
            } else {
                $('.TimeOfMonth[data-time="middle"]').removeClass('d-none');
                $('.TimeOfMonth[data-time="end"]').addClass('d-none');
            }
            var nextBoxDate1 = new Date(DateSplit[0], DateSplit[1], 1); // this already adds one to the month total because JS months start zero!

            $('.NextBoxMonth').text(monthNames[nextBoxDate1.getMonth()]);

            $('.addToCartButton').data('christmasorder', 0);
        }
        //addToCartButton

        ShowHideChristmasPostAlert();
    });

    $('input[name="Subscription.DeliveryAddress.Name"]').on('change', function () {
        var name = $(this).val().trim();
        var DeliveryAddressName = $(this).parents('form').find('.DeliveryAddressName');
        if (name === '') {
            name = DeliveryAddressName.data('default');
        }
        DeliveryAddressName.text(name);
    }).trigger('change');

    $('input[name="Subscription.FirstBoxDespatchDate"], input[name="Product.DespatchDate"]').on('change', function () {
        var despatchDate = new Date($(this).val());
        $('.FirstBoxDespatchDate').text(formatDateNicelyWithoutYear(despatchDate));

        var DoNotOpenUntil = $('input[name$="DoNotOpenUntil"]');
        var minDate = new Date(despatchDate.getFullYear(), despatchDate.getMonth(), despatchDate.getDate() + 2);
        var maxDate = new Date(minDate.getFullYear(), minDate.getMonth() + 1, minDate.getDate());
        DoNotOpenUntil.attr('min', formatDate(minDate)).attr('max', formatDate(maxDate));

        var currentDate = new Date(DoNotOpenUntil.val());
        if (DoNotOpenUntil.val() === '' || currentDate < minDate || currentDate > maxDate) {
            DoNotOpenUntil.val(formatDate(minDate));
        }
        DoNotOpenUntil.trigger('change');

        if (despatchDate.getDate() > 15) {
            $('.TimeOfMonth[data-time="middle"]').addClass('d-none');
            $('.TimeOfMonth[data-time="end"]').removeClass('d-none');
        } else {
            $('.TimeOfMonth[data-time="middle"]').removeClass('d-none');
            $('.TimeOfMonth[data-time="end"]').addClass('d-none');
        }

        var nextBoxDate = new Date(despatchDate.getFullYear(), despatchDate.getMonth() + 1, 1);
        $('.NextBoxMonth').text(monthNames[nextBoxDate.getMonth()]);

        ShowHideChristmasPostAlert();
    }).trigger('change');

    $('input[name="Subscription.FirstBoxToMe"]').on('change', function () {
        var form = $(this).parents('form');
        var checked = form.find('input[name="Subscription.FirstBoxToMe"]:checked');

        if (!checked.parents('.radio-group-item').hasClass('active')) {
            checked.parents('.radio-group').children('.radio-group-item.active').removeClass('active').children('.collapse').collapse('hide');
            checked.parents('.radio-group-item').addClass('active').children('.collapse').collapse('show');
        }

        if (checked.val().toLowerCase() === 'true') {
            form.find('input[name^="Subscription.FirstBoxAddress."]').removeAttr('disabled');
            form.find('input[name="Subscription.DoNotOpenUntilEnabled"]').attr('disabled', 'disabled');
            form.find('input[name="Subscription.DoNotOpenUntil"]').attr('disabled', 'disabled');

            form.find('.FirstBoxToMe').removeClass('d-none');
            form.find('.FirstBoxToThem').addClass('d-none');
        } else {
            form.find('input[name^="Subscription.FirstBoxAddress."]').attr('disabled', 'disabled');
            form.find('input[name="Subscription.DoNotOpenUntilEnabled"]').removeAttr('disabled').trigger('change');

            form.find('.FirstBoxToMe').addClass('d-none');
            form.find('.FirstBoxToThem').removeClass('d-none');
        }
    }).first().trigger('change');

    $('input[type="checkbox"][name$="DoNotOpenUntilEnabled"]').on('change', function () {
        if ($(this).is(':checked')) {
            $(this).parents('form').find('input[name$="DoNotOpenUntil"]').removeAttr('disabled');
        } else {
            $(this).parents('form').find('input[name$="DoNotOpenUntil"]').attr('disabled', 'disabled');
            $(this).parents('form').validate().resetForm();
        }
    }).trigger('change');

    $('input[name$="DoNotOpenUntil"]').on('change', function () {
        if ($(this).val() == '') {
            $(this).val($(this).attr('min'));
        }

        var dnoDate = new Date($(this).val());
        var despatchDate = new Date($('input[name="Subscription.FirstBoxDespatchDate"]').val());
        var nextDespatchDate = new Date(despatchDate.getFullYear(), despatchDate.getMonth() + 1, despatchDate.getDate() > 15 ? 21 : 7);

        if (dnoDate > nextDespatchDate) {
            $('.secondBoxWarning').removeClass('d-none');
        } else {
            $('.secondBoxWarning').addClass('d-none');
        }
    }).trigger('change');

    $('#AddToCartForm').on('submit', function (e) {
        var form = this;

        if ($(form).valid()) {
            $('.addToCartButton').prop('disabled', true);
            $('.addToCartButton .fas').removeClass('fa-lock-alt').addClass('fa-circle-notch fa-spin');

            if (typeof $(form).data('product') != 'undefined') {
                e.preventDefault();

                var selectedProduct = $(form).data('product');

                pintrk('track', 'addtocart', {
                    value: selectedProduct.gaPrice,
                    currency: 'GBP'
                });

                gtag('event', 'add_to_cart', {
                    'items': [
                        {
                            'id': selectedProduct.gaId,
                            'name': selectedProduct.gaName,
                            'variant': selectedProduct.gaVariant,
                            'price': selectedProduct.gaPrice,
                            'quantity': 1
                        }
                    ],
                    'event_callback': createFunctionWithTimeout(function () {
                        form.submit();
                    })
                });
            }
        }
    });

    $('.RemoveSubscription').on('click', function (e) {
        e.preventDefault();

        var target = $(this).attr('href');
        var selectedProduct = $.parseJSON($(this).siblings('.subscription-product-data').text());

        gtag('event', 'remove_from_cart', {
            'items': [
                {
                    'id': selectedProduct.gaId,
                    'name': selectedProduct.gaName,
                    'variant': selectedProduct.gaVariant,
                    'price': selectedProduct.gaPrice,
                    'quantity': 1
                }
            ],
            'event_callback': createFunctionWithTimeout(function () {
                window.location = target;
            })
        });
    });

});

function FixSubscriptionOptionsOverflow() {
    $('.subscription-options-restricted-height .form-row[data-toggle="buttons"]').each(function () {
        $(this).css('padding-right', '');

        var rowWidth = $(this).outerWidth()
        var colWidth = 0;
        var cols = $(this).children('.col.btn-group-toggle');
        cols.each(function () {
            colWidth += $(this).outerWidth();
        });

        if (colWidth > rowWidth) {
            $(this).css('padding-right', '0.1px');
        }
    });
}

function WorkOutDisplayPriceIncDelivery() {
    var PriceToShow = parseFloat($('.PriceSummary').data('price'));
    if ($('.delivery-options input[type="radio"]:visible').length > 0) {
        PriceToShow = PriceToShow + parseFloat($('.delivery-options input[type="radio"]:checked').data('cost'));
    }
    var PriceToShowAsCurrency = PriceToShow.toLocaleString('en-GB', {
        style: 'currency',
        currency: 'GBP',
    });
    //console.log(PriceToShow);
    //console.log($('.PriceSummary').data('price'));
    $('.PriceSummary').text(PriceToShowAsCurrency);
}

function SetSubscriptionSummary() {
    var optionChecked = $('.btn input[name="OptionId"]:checked');
    var quantityChecked = $('.btn input[name="Quantity"]:checked');
    var planChecked = $('.btn input[name="PlanLength"]:checked');

    $('.ProductName').text($('#ProductName').text());
    $('.ProductSummary').text($('#ProductSummary').text().replace('{quantity}', quantityChecked.parents('.btn').find('.quantity').first().text()));
    $('.DurationSummary').text(planChecked.parents('.btn').find('span.duration').first().text());
    //$('.PriceSummary').text(planChecked.parents('.btn').find('.price:visible').first().text());
    //console.log(planChecked.parents('.btn').find('.price:visible').first().data('price'));
    $('.PriceSummary').data('price', planChecked.parents('.btn').find('.price:visible').first().data('price'));

    WorkOutDisplayPriceIncDelivery();

    var subscriptionProductData = $.parseJSON($('.subscription-product-data').text());
    var selectedProduct = $.grep(subscriptionProductData, function (el) {
        return el.optionId === parseInt(optionChecked.val())
            && el.quantity === parseInt(quantityChecked.val())
            && el.planLength === parseInt(planChecked.val());
    })[0];

    if (typeof $('#AddToCartForm').data('product') == 'undefined' || selectedProduct.id != $('#AddToCartForm').data('product').id) {
        $('#AddToCartForm').data('product', selectedProduct);

        gtag('event', 'view_item', {
            'items': [
                {
                    'id': selectedProduct.gaId,
                    'name': selectedProduct.gaName,
                    'variant': selectedProduct.gaVariant,
                    'price': selectedProduct.gaPrice,
                    'quantity': 1
                }
            ]
        });
    }
}

function ShowHidePlans() {
    $('.btn input[name="PlanLength"]').each(function () {
        $(this).parents('.col').removeClass('d-none');
        if ($(this).parents('.btn').find('.plan-details:not(.d-none)').length == 0) {
            $(this).parents('.col').addClass('d-none');
            if ($(this).is(':checked')) {
                $('.btn input[name="PlanLength"]:not(.d-none)').first().parents('.btn').trigger('click');
            }
        }
    });
}

function ShowHideChristmasPostAlert() {
    var ChristmasPostAlert = $('.christmas-post-alert');
    if (ChristmasPostAlert.length) {
        var DespatchDate = new Date($('input[name="Subscription.FirstBoxDespatchDate"]').val());
        var ChristmasPostAlertDate = new Date(ChristmasPostAlert.data('date'));
        if (DespatchDate.getTime() == ChristmasPostAlertDate.getTime() && $('input[name$=".GiftMessageThemeId"]:checked').val() == '6') {
            ChristmasPostAlert.removeClass('d-none');
        } else {
            ChristmasPostAlert.addClass('d-none');
        }
    }
}